import type { SvgIconComponent } from '@mui/icons-material';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import DifferenceOutlinedIcon from '@mui/icons-material/DifferenceOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import JoinInnerOutlinedIcon from '@mui/icons-material/JoinInnerOutlined';
import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import ToggleOnOutlinedIcon from '@mui/icons-material/ToggleOnOutlined';

type SectionItem = {
  id: string;
  label: string;
  Icon: SvgIconComponent;
};

export type Section = {
  label: string;
  items: SectionItem[];
};

export const SIDEBAR_SECTIONS: Section[] = [
  {
    label: 'Overview',
    items: [
      { id: 'dashboard', label: 'Dashboard', Icon: GridViewOutlinedIcon },
      { id: 'roster', label: 'Students', Icon: GroupsOutlinedIcon },
    ],
  },
  {
    label: 'Plans & Reports',
    items: [{ id: 'reports', label: 'Reports', Icon: SummarizeOutlinedIcon }],
  },
  {
    label: 'Data Management',
    items: [
      { id: 'data', label: 'Data & Integrations', Icon: StorageOutlinedIcon },
      { id: 'settings', label: 'Settings', Icon: SettingsOutlinedIcon },
    ],
  },
];

export const ADMIN_SECTION: Section = {
  label: 'Admin',
  items: [
    { id: 'peAdmin', label: 'Program Evaluations', Icon: AdminPanelSettingsOutlinedIcon },
    { id: 'uploadsAdmin', label: 'Uploaded Files', Icon: FolderOutlinedIcon },
    { id: 'analyticsAdmin', label: 'Analytics', Icon: InsightsOutlinedIcon },
    { id: 'impersonationAdmin', label: 'Impersonate', Icon: PersonSearchOutlinedIcon },
    { id: 'progressReportAuditAdmin', label: 'Report Audit', Icon: ChecklistOutlinedIcon },
    { id: 'criteriaDifferencesAdmin', label: 'Criteria differences', Icon: DifferenceOutlinedIcon },
    { id: 'sisMatchingAdmin', label: 'SIS matching', Icon: JoinInnerOutlinedIcon },
    { id: 'featureFlagsAdmin', label: 'Feature flags', Icon: ToggleOnOutlinedIcon },
  ],
};

export const TEACHER_NAV_IDS: readonly string[] = ['roster', 'reports'];
export const DISTRICT_ADMIN_NAV_IDS: readonly string[] = ['dashboard', 'roster', 'reports', 'data', 'settings'];

export type NavRole = { isSuperAdmin: boolean; isDistrictAdmin: boolean };

export function sectionsForRole(sections: Section[], role: NavRole): Section[] {
  if (role.isSuperAdmin) return [...sections, ADMIN_SECTION];
  const allowed = role.isDistrictAdmin ? DISTRICT_ADMIN_NAV_IDS : TEACHER_NAV_IDS;
  return sections
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => allowed.includes(item.id)),
    }))
    .filter((section) => section.items.length > 0);
}
